import { computed, Injectable, signal } from '@angular/core';
import { BreadcrumbItem } from './';
import { buildBreadcrumbsConfig } from './breadcrumb-builder.util';

@Injectable({
  providedIn: 'root',
})
export class BreadcrumbsService {
  config = signal<BreadcrumbItem[]>([]);
  isLoading = computed(() => this.config().length <= 1);

  set(...args: Parameters<typeof buildBreadcrumbsConfig>): void {
    this.config.set(buildBreadcrumbsConfig(args[0], { ...this.defaultOptions, ...(args[1] ?? {}) }));
  }

  private get defaultOptions() {
    return {
      withRootSegment: true,
      rootSegmentConfig: {
        label: 'Home',
        path: '',
      },
    };
  }
}
